(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardCacmController', Controller);

    Controller.$inject = ['$scope', '$q', 'cacmService'];

    function Controller($scope, $q, cacmService) {
        
        $q.all({
            lkups: cacmService.getAllLookups(),
            evtsSummary: cacmService.getCACMEventsSummary()
        }).then(function (results) {
            var evtStatusByTitleEN = _.chain(results.lkups.CACMEventStatuses)
                                        .groupBy('TitleEN')
                                        .mapValues(function (status) {
                                            return status[0];
                                        })
                                        .value();

            var controlAreasByName = _.chain(results.lkups.CACMControlAreas)
                                        .groupBy('Name')
                                        .mapValues(function (cAreas) {
                                            return cAreas[0];
                                        })
                                        .value();

            var evtsSummary = results.evtsSummary;

            // Init control areas with all events control area
            var allEvtsCtrlArea = {
                Name: 'All Events',
                eventsCount: evtsSummary.response.numFound
            }

            $scope.showDashboard = allEvtsCtrlArea.eventsCount > 0;

            allEvtsCtrlArea.statuses =
                    _.chain(evtsSummary.facet_counts.facet_fields.Status)
                    .chunk(2) // From ["Value", Count, "Value", Count, ...] => [{value: "Value", count: Count }, ...]
                    .map(function (valueCountPair) {
                        var value = valueCountPair[0];
                        var count = valueCountPair[1];

                        var status = _.clone(evtStatusByTitleEN[value]);
                        status.eventsCount = count;
                        status.eventsCountRatio = status.eventsCount / allEvtsCtrlArea.eventsCount;
                        status.eventsCountPercentage = status.eventsCountRatio * 100;

                        return status;
                    })
                    .value();

            var ctrlAreas = [allEvtsCtrlArea];

            _.forEach(evtsSummary.facet_counts.facet_pivot['ControlArea,Status'], function (cArea) {
                var controlArea = _.clone(controlAreasByName[cArea.value]);
                controlArea.eventsCount = cArea.count;

                controlArea.statuses = _.map(cArea.pivot, function (cAreaStatus) {
                    var status = _.clone(evtStatusByTitleEN[cAreaStatus.value]);
                    status.eventsCount = cAreaStatus.count;
                    status.eventsCountRatio = status.eventsCount / controlArea.eventsCount;
                    status.eventsCountPercentage = status.eventsCountRatio * 100;

                    return status;
                });

                ctrlAreas.push(controlArea);
            });

            $scope.ctrlAreas = ctrlAreas;
        });
    }
})();